var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-section" }, [
    _c("div", { staticClass: "filters-main-container" }, [
      _c("div", { staticClass: "scrollable-filters-wrapper" }, [
        _c(
          "div",
          { ref: "scrollableFilters", staticClass: "scrollable-filters" },
          [
            _c("FilterChip", {
              attrs: {
                type: "select",
                value: _vm.cloneState,
                options: _vm.stateOptions,
                "operator-selectable": false,
              },
              on: {
                change: function ($event) {
                  return _vm.onStateChange($event)
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.staticFilterTemplates, function (filter) {
              return _c("FilterChip", {
                key: filter.field,
                ref: "staticFilterChip_" + filter.field,
                refInFor: true,
                attrs: {
                  "data-filter-field": filter.field,
                  dataFilterField: filter.field,
                  type: filter.type,
                  value: _vm.getFilterValue(filter),
                  valueText: _vm.getFilterValueText(filter),
                  options: filter.options,
                  multiple: filter.multiple,
                  "enable-search": filter.search,
                  icon: filter.icon || "label",
                  "filter-name": filter.label,
                  "operator-selectable": filter.operatorSelectable,
                  operator: _vm.getFilterOperator(filter),
                  clearable: true,
                },
                on: {
                  clear: function ($event) {
                    return _vm.clearFilter(filter)
                  },
                  change: function ($event) {
                    return _vm.onFilterChange(filter, $event)
                  },
                  "operator-change": function ($event) {
                    return _vm.onOperatorChange(filter, $event)
                  },
                },
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.getSelectedDynamicFilters(), function (filter) {
              return _c("FilterChip", {
                key: filter.field,
                ref: "filterChip_" + filter.field,
                refInFor: true,
                attrs: {
                  "data-filter-field": filter.field,
                  dataFilterField: filter.field,
                  type: filter.type,
                  value: _vm.getFilterValue(filter),
                  valueText: _vm.getFilterValueText(filter),
                  options: filter.options,
                  multiple: filter.multiple,
                  icon: filter.icon || "label",
                  "filter-name": filter.label,
                  removable: true,
                  "operator-selectable": filter.operatorSelectable,
                  operator: _vm.getFilterOperator(filter),
                  "enable-search": filter.search,
                  "composite-select-label": filter.compositeSelectLabel,
                  "composite-input-label": filter.compositeInputLabel,
                  "composite-input-placeholder":
                    filter.compositeInputPlaceholder,
                },
                on: {
                  change: function ($event) {
                    return _vm.onFilterChange(filter, $event)
                  },
                  remove: function ($event) {
                    return _vm.removeDynamicFilter(filter)
                  },
                  "operator-change": function ($event) {
                    return _vm.onOperatorChange(filter, $event)
                  },
                },
              })
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-buttons-container" },
      [
        _c("FilterChip", {
          ref: "filterAddChip",
          staticClass: "filter-add-chip",
          attrs: {
            type: "add",
            multiple: true,
            value: _vm.selectedDynamicFilters,
            options: _vm.dynamicFilterOptions,
            "enable-search": true,
            label: _vm.$t("chat.filtersSection.addFilter"),
          },
          on: { change: _vm.addDynamicFilter },
        }),
        _vm._v(" "),
        !_vm.sortDisabled
          ? _c("FilterChip", {
              attrs: {
                type: "select",
                value: _vm.sortValue,
                options: _vm.sortOptions,
                "operator-selectable": false,
                "enable-search": false,
              },
              on: { change: _vm.onSortChange },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }